import React from "react";
import { useNavigate } from "react-router-dom";
import LeftSide from "../pageComponents/LeftSide";
import styles from "../../assets/styles/Login/Login.module.scss";
import ResetPasswordForm from "./ResetPasswordForm";

const ResetPassword = ({ validationSchema, onSubmit, loading }) => {
  return (
    <div className={styles.container}>
      <LeftSide title="Welcome Back :)" />
      <div className={styles.rightside}>
        <div className={styles.logintext__center}>
          <h3 className={`${styles.logintext__title} ${styles.mb_30}`}>
            Reset Your Password
          </h3>
        </div>
        <div className={styles.loginform}>
          <ResetPasswordForm
          	validationSchema={validationSchema}
            onSubmit={onSubmit}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
